export enum EOverlayEventType {
  ShowMessage = 10,
  ClearMessage = 11,
}
